/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

const BASE_API_URL = "viacal/public";

export const ABSENCES_GET_API_URL = `${BASE_API_URL}/absences/get`;
export const ABSENCE_APPLY_API_URL = `${BASE_API_URL}/absences/create`;
export const ABSENCE_CANCEL_API_URL = `${BASE_API_URL}/absences/cancel`;
export const ABSENCE_FILE_DOWNLOAD_API_URL = `${BASE_API_URL}/absences/file`;
export const ABSENCE_GET_ATTACHMENT_UPLOAD_URL = `${BASE_API_URL}/absences/upload-url`;

export const SCHEDULE_API_URL = `${BASE_API_URL}/schedule`;
export const UNCLAIM_SHIFT_API_URL = `${BASE_API_URL}/shifts/unclaim`;
export const CLAIM_SHIFT_INTENTION_API_URL = `${BASE_API_URL}/shifts/intention`;
export const SHIFT_CLAIMS_STATUSES_API_URL = `${BASE_API_URL}/shifts/claim/statuses`;

export const SHIFT_BATCHES_URL = `${BASE_API_URL}/shifts/batches`;
export const CLAIM_SHIFT_BATCHES_API_URL = `${BASE_API_URL}/shifts/batches/claim`;


export const RATES_API_URL = `${BASE_API_URL}/rates`;

export const FE_CONFIGS_API_URL = `${BASE_API_URL}/fe-configs`;

export const DRM_DRIVER_ID_API_URL = "driver-login/id2?identifier=%2B";
